import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React from 'react';

import {
  FilterOption,
  FilterOptionsResponse,
} from '../../../utils/backend-api/subscriber_directory';
import styles from './styles.module.css';

const ENTITY_SECTION_NAMES = {
  openTo: 'Open To',
  company: 'Company',
  location: 'Location',
  skills: 'Skills',
  topics: 'Topics',
  favoriteVacationSpots: 'Fav. Vacation Spots',
  favoriteSportPlay: 'Fav. Sports to Play',
  favoriteSportWatch: 'Fav. Sports to Watch',
  favoriteBook: 'Fav. Books',
  favoriteShow: 'Fav. Shows / Movies',
};

const ClearFilterButton = ({
  name,
  onClick,
  isLast,
}: {
  name: string;
  onClick: () => void;
  isLast: boolean;
}) => {
  return (
    <button
      className={clsx(styles.clearFilterButton, {
        [styles.lastClearFilterButton]: isLast,
      })}
      type="button"
      onClick={onClick}
      data-test="clear-filter-button"
    >
      {name}
      <span className={styles.clearFilterButtonX}>&#10005;</span>
    </button>
  );
};

const ClearFilterButtons = ({ name, options }: { name: string; options: FilterOption[] }) => {
  const { values, setFieldValue } = useFormikContext();
  const sectionValues = values[name];
  if (!sectionValues?.length) return null;

  const getOptionLabel = (value) => options?.find((option) => option.value === value)?.label;
  const removeFilter = (value) => {
    const existingValues = values[name];
    const newValue = Array.isArray(existingValues)
      ? values[name].filter((existingValue) => existingValue !== value)
      : '';
    setFieldValue(name, newValue);
  };
  const sectionValuesArr = [sectionValues].flatMap((value) => value);

  return (
    <>
      <div className={styles.clearFilterGroupLabel}>{ENTITY_SECTION_NAMES[name]}:</div>
      {sectionValuesArr.map((value, index) => {
        return (
          <ClearFilterButton
            key={index}
            onClick={() => removeFilter(value)}
            name={getOptionLabel(value)}
            isLast={index === sectionValuesArr.length - 1}
          />
        );
      })}
    </>
  );
};

const ClearFilterSection = (props: FilterOptionsResponse) => {
  return (
    <div className={styles.clearFilterSection}>
      {Object.keys(ENTITY_SECTION_NAMES).map((name) => (
        <ClearFilterButtons name={name} key={name} options={props[`${name}Options`]} />
      ))}
    </div>
  );
};

export default ClearFilterSection;
